// @flow
import {combineReducers} from 'redux';
import type {TMapCalcState} from 'modules/map/reducers/map-calc';
import {mapCalcReducer} from 'modules/map/reducers/map-calc';
import {mapModule} from 'us-csg-game-common';
import type {TMapState} from 'us-csg-game-common';

const reducers = {
    map: mapModule.mapReducer,
    mapCalc: mapCalcReducer,
};

type TMapModuleState = {
    map: TMapState,
    mapCalc: TMapCalcState,
};

const mapModuleReducer = combineReducers(reducers);
export {mapModuleReducer};
export type {TMapModuleState};
